import { render, staticRenderFns } from "./SkinPricingHistoryChart.vue?vue&type=template&id=1bafe31e&scoped=true&"
import script from "./SkinPricingHistoryChart.vue?vue&type=script&lang=ts&"
export * from "./SkinPricingHistoryChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bafe31e",
  null
  
)

export default component.exports